// extracted by mini-css-extract-plugin
export default {"checkbox":"VTEC9","align-items-center":"_37iG0","alignItemsCenter":"_37iG0","label":"SbrAU"};